"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var util_1 = require("@aperza/util");
var appConfig = util_1.AppService.appConfig();
var CategoryItem2 = /** @class */ (function (_super) {
    __extends(CategoryItem2, _super);
    function CategoryItem2(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { over: false };
        return _this;
    }
    CategoryItem2.prototype.onClick = function () {
        var _a = this.props.productCategory, name = _a.name, displayCategoryId = _a.displayCategoryId;
        if (!this.props.disableMarketplaceBanner) {
            window.location.href = appConfig.marketplaceWebHost + "/" + appConfig.langCode + "/s/item/?rf=1108&fc=%7C" + this.props.parentDisplayCategoryId + "%7C" + displayCategoryId + "&k=";
        }
        else if (util_1.AppConfigService.shouldShowMarketplaceTopBanner()) {
            window.location.href = appConfig.searchWebHost + "/" + appConfig.langCode + "/s/item/?rf=1108&fc=%7C" + this.props.parentDisplayCategoryId + "%7C" + displayCategoryId + "&k=";
        }
        else {
            window.location.href = appConfig.searchWebHost + "/" + appConfig.langCode + "/c/2/" + encodeURIComponent(name) + "/" + this.props.parentDisplayCategoryId + "/" + displayCategoryId + "/index.html";
        }
    };
    CategoryItem2.prototype.render = function () {
        var _a = this.props.productCategory, name = _a.name, itemCount = _a.itemCount;
        return (react_1.default.createElement("div", { className: "categoryItem", onClick: this.onClick.bind(this) },
            react_1.default.createElement("p", { className: "name" },
                react_1.default.createElement("span", null, name),
                react_1.default.createElement("span", { className: "number" },
                    "(",
                    itemCount.toLocaleString('en'),
                    ")"))));
    };
    CategoryItem2.propTypes = {
        parentDisplayCategoryId: prop_types_1.default.number.isRequired,
        productCategory: prop_types_1.default.shape({
            name: prop_types_1.default.string.isRequired,
            displayCategoryId: prop_types_1.default.number.isRequired,
            itemCount: prop_types_1.default.number.isRequired,
            disableMarketplaceBanner: prop_types_1.default.bool,
        }).isRequired,
    };
    return CategoryItem2;
}(react_1.default.Component));
exports.default = CategoryItem2;
